<template>
  <v-layout justify-center>
    <v-flex xs12 sm6 md4 lg3>
      <v-card>
        <v-card-title primary-title>
          <div style='width:100%;'>
            <h3 class="headline mb-0">Login</h3>
            <v-form @submit="processLogin" v-model="login">
              <v-text-field
                value=""
                v-model="email"
                label="Email"
                :rules="emailRules"
                required
              ></v-text-field>
              <v-text-field
                value=""
                type="password"
                label="Password"
                v-model="password"
                :rules="passwordRules"
                required
              ></v-text-field>
              <v-btn type="submit">login</v-btn>
            </v-form>
          </div>
        </v-card-title>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import Cookies from "js-cookie";
import axios from 'axios';
import {Notifications} from "../notification";
import {UserSession, UserSessionMod} from "../user_session";

export default{
  name: "Login",
  data() {
    return {
      login: false,
      email: "",
      password: "",

      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid'
      ],
      passwordRules: [
        v => !!v || 'Password is required'
      ]
    }
  },
  methods: {
    processLogin(e){
      var global_this = this;
      e.preventDefault();

      axios({
        url: this.$API_ENDPOINT + "/console_api/v1/auth/login.php",
        method: 'POST',
        data: {
          _console_token: UserSession.token,
          email: this.email,
          password: this.password
        }
      }).then(function(response) {
        if(response.data.status === 200){
          //Login was successful
          Cookies.set("_console_token", response.data.body._console_token, { expires: 7 }); //To stay 7 days logged in
          UserSessionMod.setToken(response.data.body._console_token);
          global_this.$router.replace("dashboard");
          Notifications.show("Welcome back.");
        } else {
          Notifications.show(response.data.message);
        }
      });
    }
  }
}
</script>
